import React from 'react';
import { CheckSquare } from 'lucide-react';
export function PainChecklist() {
  const items = ['¿Llegás a las 4pm con un antojo que ninguna fruta puede callar?', '¿Sentís culpa cada vez que comés algo dulce?', '¿El lunes empezás de nuevo y el viernes ya "te arruinaste"?', '¿Sabés qué "deberías" comer pero tu cuerpo pide otra cosa?'];
  return <section className="bg-white py-16 px-4" data-id="element-210">
      <div className="max-w-3xl mx-auto" data-id="element-211">
        <h3 className="text-2xl font-bold text-chocolate-900 mb-8 text-center" data-id="element-212">
          Respondé honestamente:
        </h3>

        <div className="space-y-6 bg-chocolate-50 p-8 rounded-2xl border border-chocolate-800/10 shadow-sm" data-id="element-213">
          {items.map((item, index) => <div key={index} className="flex items-start space-x-4" data-id="element-214">
              <CheckSquare className="w-6 h-6 text-pain flex-shrink-0 mt-1" data-id="element-215" />
              <p className="text-lg md:text-xl text-chocolate-800 font-medium" data-id="element-216">
                {item}
              </p>
            </div>)}
        </div>

        <div className="mt-10 text-center" data-id="element-217">
          <p className="text-xl md:text-2xl font-bold text-chocolate-900" data-id="element-218">
            Si marcaste 2 o más... no es falta de voluntad.
          </p>
          <p className="text-lg md:text-xl text-chocolate-800 mt-2" data-id="element-219">
            Es que nadie te explicó cómo funciona tu cerebro con el dulce.
          </p>
        </div>
      </div>
    </section>;
}